// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-content-details[data-v-ef526768] {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n.icon[data-v-ef526768] {\n\theight: 64px;\n\twidth: 64px;\n\tmargin: 0 auto 15px;\n\tbackground-size: 64px;\n\topacity: 0.4;\n}\nh2[data-v-ef526768],\np[data-v-ef526768] {\n\ttext-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
